<template>
  <div class="app">
    <van-image width="100%" fit="fill" :src="require('../assets/bg@2x.png')" />
    <van-button
      style="width: 80%; height: 34pt; margin: 32pt"
      round
      type="info"
      @click="go"
      >Make money now</van-button
    >
  </div>
</template>
<script>
import Vue from "vue";
import { Image as VanImage } from "vant";
import { Button } from "vant";
Vue.use(VanImage);
Vue.use(Button);
export default {
  name: "Phone",
  components: { VanImage, Button },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    go() {
      if (this.$route.query.inviteCode) {
        this.$router.push({
          path: "/register",
          query: { inviteCode: this.$route.query.inviteCode },
        });
      }
    },
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

.app {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
